export default __webpack_public_path__ + "static/media/sweet-2.200aa8d0.jpeg";